import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { WalletProvider } from "./contexts/WalletContext";
import { TransactionProvider } from "./contexts/TransactionContext";
import "./index.css";
import { GlobalProvider } from "./contexts/GlobalContext";
import { ZombieProvider } from "./contexts/ZombieContext";

ReactDOM.render(
	<React.StrictMode>
		<GlobalProvider>
			<WalletProvider>
				<TransactionProvider>
					<ZombieProvider>
						<App />
					</ZombieProvider>
				</TransactionProvider>
			</WalletProvider>
		</GlobalProvider>
	</React.StrictMode>,

	document.getElementById("root")
);
